import { render, staticRenderFns } from "./AboutUs_IT.vue?vue&type=template&id=c6fbb3fc&scoped=true&"
import script from "./AboutUs_IT.vue?vue&type=script&lang=js&"
export * from "./AboutUs_IT.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs_IT.vue?vue&type=style&index=0&id=c6fbb3fc&prod&lang=css&"
import style1 from "./AboutUs_IT.vue?vue&type=style&index=1&id=c6fbb3fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fbb3fc",
  null
  
)

export default component.exports